module.exports = __webpack_public_path__ + "img/clapp-logo.a7acde07.jpeg";